const block = document.querySelector('.wp-block-supertheme-home-hero');

if (block) {
    animate();

    function animate() {
        const slides = document.querySelectorAll('.hero-slider--single');
        const greyTiles = document.querySelectorAll('.hero-slider--layer-1');
        const slideCount = slides.length;
        let duration = 6;
        let x = '';
        let y = '';

        if (window.innerWidth > 1200) {
            x = `-${window.innerHeight / 2.8}%`
            y = `${window.innerHeight / 2.8}%`
        }
        else if (window.innerWidth > 767 && window.innerWidth < 1200) {
            x = "-350%"
            y = "420%"
        }

        if (window.innerWidth > 767) {
            if (slides) {
                slides.forEach((dot, i) => {
                    gsap.to(dot, {
                        x: x,
                        y: y,
                        duration: duration,
                        ease: "slow(0.2, 0.8, false)",
                        delay: i * duration,
                        repeat: -1,
                        repeatDelay: duration * (slideCount - 1),
                    });
                });

                gsap.to('.slide-1', {
                    x: x,
                    y: y,
                    duration: duration,
                    ease: "slow(0.3, 0.7, false)",
                    repeat: -1
                });
            }

            if (greyTiles) {
                greyTiles.forEach((tile, i) => {
                    gsap.to(tile, {
                        x: "-200%",
                        y: "200%",
                        duration: 50,
                        ease: Linear.easeNone,
                        repeat: -1,
                    });
                })
            }
        }
        else {
            if (slides) {
                slides.forEach((dot, i) => {
                    gsap.to(dot, {
                        x: "-300%",
                        y: "60%",
                        duration: duration,
                        ease: "slow(0.2, 0.8, false)",
                        delay: i * duration,
                        repeat: -1,
                        repeatDelay: duration * (slideCount - 1),
                    });
                });
            }

            if (greyTiles) {
                greyTiles.forEach((tile, i) => {
                    gsap.to(tile, {
                        x: "-200%",
                        y: "50%",
                        duration: 50,
                        ease: Linear.easeNone,
                        repeat: -1,
                    });
                })
            }

            gsap.to('.slide-1', {
                x: "-250%",
                y: "50%",
                duration: duration,
                ease: "slow(0.2, 0.8, false)",
                repeat: -1
            });
        }

    }
}